import React from 'react'
// import ArtplayerComponent from 'artplayer-react'

import { Player, ArtplayerComponent } from './styles'

export default React.memo(
  function({ options, setPlayer, setCurrentTime }) {
    return (
      <Player>
        <ArtplayerComponent
          style={{
            width: '800px',
            height: '500px',
            fontSize: '1.5rem',
          }}
          option={{
            url: options.videoUrl,
            loop: true,
            autoSize: true,
            aspectRatio: true,
            playbackRate: true,
            fullscreen: true,
            fullscreenWeb: true,
            miniProgressBar: true,
            hotkey: true,
            subtitle: {
              url: options.subtitleUrl,
            },
            highlight: [
              {
                time: 5,
                text: 'AGORA DA PRA COLOCAR',
              },
              {
                time: 10,
                text: 'ANOTAÇÕES',
              },
              {
                time: 20,
                text: ':D',
              },
            ],
            moreVideoAttr: {
              crossOrigin: 'anonymous',
              preload: 'auto',
            },
          }}
          getInstance={art => {
            setPlayer(art)
            ;(function loop() {
              window.requestAnimationFrame(() => {
                if (art.playing) {
                  setCurrentTime(art.currentTime)
                }
                loop()
              })
            })()

            art.on('seek', () => {
              setCurrentTime(art.currentTime)
            })
          }}
        />
      </Player>
    )
  },
  () => true
)
